import { render, staticRenderFns } from "./Dragable.vue?vue&type=template&id=226a396e"
import script from "./Dragable.vue?vue&type=script&lang=js"
export * from "./Dragable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports